import * as React from 'react';
export const IcCloudy = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.9 11.5a5.002 5.002 0 00-4.9-6c-1.67 0-3.15.83-4.06 2.1-.31-.06-.62-.1-.94-.1-2.61 0-4.72 2-4.95 4.55A3.487 3.487 0 002 15.5C2 17.43 3.57 19 5.5 19H18c2.21 0 4-1.79 4-4 0-1.52-.86-2.82-2.1-3.5z'
      fill='currentColor'
    />
  </svg>
);
